import { Resolvers } from "@apollo/client";

const resolvers: Resolvers = {};

export default resolvers;
